<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      selectedModule: '',
      modules: [
        { label: 'Dashboard', value: '' },
        { label: 'DCALL BILLING', value: 'call-accounting' },
        { label: 'AUTO Dialer', value: 'dialer' },
        { label: 'DCALL Recordings', value: 'recordings' },
        { label: 'DCALL Stats', value: 'stats/login' },
        { label: 'DCALL Switchboard', value: 'live-monitoring' },
        { label: 'DCALL WEB PHONE', value: 'webrtc' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      currentAccountId: 'getCurrentAccountId',
    }),
    voice_agent_url() {
      return `https://cloud.dcall.sa/${this.selectedModule}`;
    },
    currentAccount() {
      return this.getAccount(this.currentAccountId);
    },
  },
  mounted() {
    this.initializeIframe();
  },
  methods: {
    handleModuleChange() {
      this.$nextTick(() => {
        this.initializeIframe();
      });
    },
    initializeIframe() {
      const iframe = this.$refs.voiceAgentFrame;
      if (!iframe) return;
      const creds = this.currentAccount?.custom_attributes?.vital || {};
      if (!creds.username || !creds.password) return;

      let attempts = 0;
      const maxAttempts = 20; // e.g. try for 10 seconds
      const interval = setInterval(() => {
        if (attempts >= maxAttempts) {
          clearInterval(interval);
          return;
        }
        iframe.contentWindow.postMessage(
          {
            type: 'loginData',
            username: creds.username,
            password: creds.password,
          },
          '*'
        );
        attempts += 1;
      }, 500);

      iframe.addEventListener('load', () => {
        attempts = 0; // reset attempts on reload
      });
    },
  },
};
</script>

<template>
  <div class="h-full w-full flex flex-col">
    <div class="p-4 flex items-center">
      <div class="select-wrapper">
        <select
          v-model="selectedModule"
          class="select-module bg-n-background text-n-slate-12 border border-n-weak appearance-none"
          @change="handleModuleChange"
        >
          <option
            v-for="module in modules"
            :key="module.value"
            :value="module.value"
          >
            {{ module.label }}
          </option>
        </select>
        <span class="dropdown-icon text-n-slate-11">
          <i class="i-lucide-chevron-down" />
        </span>
      </div>
    </div>
    <div class="flex-grow">
      <iframe
        ref="voiceAgentFrame"
        :src="voice_agent_url"
        height="100%"
        width="100%"
        frameborder="0"
        allow="fullscreen; camera; microphone; clipboard-read; clipboard-write; autoplay; encrypted-media"
      />
    </div>
  </div>
</template>

<style scoped>
.h-full {
  height: 100%;
}

.select-wrapper {
  position: relative;
  display: inline-block;
  min-width: 200px;
}

.select-module {
  padding: 0.5rem 2.5rem 0.5rem 0.75rem;
  border-radius: 4px;
  min-width: 200px;
  font-size: 0.95rem;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  font-weight: 500;
  cursor: pointer;
}

.select-module:focus {
  outline: none;
  border-color: var(--w-500);
  box-shadow: 0 0 0 2px rgba(var(--w-500-rgb), 0.1);
}

.dropdown-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  align-items: center;
}

:dir(ltr) .dropdown-icon {
  right: 0.75rem;
  left: auto;
}

:dir(rtl) .dropdown-icon {
  left: 0.75rem;
  right: auto;
}

.dropdown-icon .i-lucide-chevron-down {
  font-size: 1.1rem;
  line-height: 1;
}
</style>
